import React from "react";

const ProjectVideo = ({ src, autoPlay = false, height = 400 }) => (
  <video
    key={src}
    width="100%"
    height={height}
    playsInline
    autoPlay={autoPlay}
    controls
    src={src}
    style={{ width: "100%", display: "block" }}
  />
);

export default ProjectVideo;
